<template>
  <div class="view login">
    <loader v-if="loading"/>
    <transition name="fade">
      <template  v-if="!loading">

      </template>
    </transition>
  </div>
</template>

<script>
import Loader from '@/components/components/Loader.vue';

export default {
  components: {
    Loader,
  },

  computed: {
    content() {
      return this.$store.state.exhibitions.item;
    },
    terms() {
      return this.$store.state.terms.item;
    },
    termsLoading() {
      return this.$store.state.terms.requests !== 0;
    },
    loading() {
      return this.$store.state.exhibitions.requests !== 0;
    }
  },
  watch: {
    $route(newRoute) {
      const { locale } = newRoute.params;
      const exhibitionId = newRoute.params.id;
      this.$store.dispatch('exhibitions/getDetail', { id: exhibitionId, loc: locale });
      this.$store.dispatch('terms/get', locale);
    },
  },
  async beforeMount() {
    const locale = localStorage.getItem('lang') || this.$route.params?.locale;

    const exhibitionId = this.$route.params.id;
    const access_token = localStorage.getItem('access_token')
    
    if(!access_token) {
      const response = await this.$store.dispatch('signup/register', { loc: locale });
      await this.$store.dispatch('login/emailLogin', { loginResponse: response });
    } else {
      
      const accessTokenExpiration = localStorage.getItem('access_token_expiration')
      const response = { access_token, accessTokenExpiration }
      await this.$store.dispatch('login/emailLogin', { loginResponse: response });
      
      if (!this.$store.state.exhibitions.item || this.$store.state.exhibitions.item.id !== exhibitionId) {
        this.$store.dispatch('exhibitions/getDetail', { id: exhibitionId, loc: locale });
      }
      if (!this.$store.state.terms.item) {
        this.$store.dispatch('terms/get', locale);
      }
    }
  },
  methods: {
    setSignupFormTitle(e) {
      if (e === 'facebook') {
        this.signupFormTitle = this.$i18n.t('signup.facebook');
      }
    },
    getTo(name) {
      const locale = localStorage.getItem('lang') || 'ko';
      return `/${locale}/${name}`;
    },
  }
};
</script>

<style lang="scss" scoped>
.view {
  position: relative;
  padding-top: 0;
  background-color: $primary;

  &-background {
    @include position(absolute, 0 0 0 0);
    @include size(100%);
    z-index: -1;
    img {
      @include position(absolute, 0 0 0 0);
      @include size(100%);
      object-fit: cover;
    }
  }

  &-content {
    min-height: 100vh;
    position: relative;
    z-index: 2;
    text-align: center;
    .container {
      min-height: 100vh;
      padding: 0 20px 60px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }

  &-head {
    .logo {
      @include size(210px,71px);
      margin: 0 auto;
      img {
        @include size(100%);
        object-fit: cover;
      }
    }
    &-title {
      @include margin(null null 20px);
      font-size: rem(37px);
    }
    &-tagline {
      @include font('primary', 'regular');
      display: block;
      font-size: rem(12px);
    }
    /* .lang {
      @include position(absolute, 25px 20px null null);
    } */
  }

  &-bottom {
    &-title {
      @include margin(null null 15px);
      line-height: 1.1;
    }
    &-text {
      color: $white;
    }
    .btn {
      width: 100%;
      + .btn {
        @include margin(20px null null);
      }
    }
  }

  .modal-terms-button {
    width: 100%;
    @include margin(20px 0 0);
    @include font('primary', 'bold');
    @include padding(17px 20px 15px);
    position: relative;
    display: inline-block;
    border: 1px solid $primary;
    border-radius: 24px;
    outline: none;
    background-color: $primary;
    color: $tertiary;
    font-size: rem(12px);
    line-height: 1;
    text-align: center;
    text-transform: uppercase;
  }

  // Loader
  // -----------------------------------------------------------------------------
  .loader {
    @include position(absolute, 50% null null 50%);
    transform: translate(-50%, -50%);
  }
}
</style>
